import {mapFilters} from "@/utils/helpers";

const initState = () => ({
  orders: {
    total: 0,
    items: [],
    options: {},
  },
  orderNotes: [],
  orderItemImages: [],
  jobOrderItems: [],

})

export const state = initState

export const getters = {
}
export const mutations = {

  setOrderNotes(state, {notes}) {
    state.orderNotes = notes
  },

  setOrderItemImages(state, {images}) {
    state.orderItemImages = images
  },

  setJobImages(state, {jobImages}) {
    state.jobImages = jobImages
  },
  spliceOrderNoteAttachment(state, {attachment}){
    let note = state.orderNotes.find(on => on.id === attachment.noteId)
    if (note) {
      note.noteAttachments.splice(attachment.index, 1)
    }

  }
}

export const actions = {

  async fetchOrderNotes({commit, state}, {jobID}) {
    const result = await this.$axios.$get(`/webpos/order/${jobID}/notes`)

    if (result.value) {
      commit('setOrderNotes', {notes: result.value})
    }
    return result
  },

  async saveOrderNote({commit, state}, {formData}) {
    try {
      const response = await this.$axios.$post(`/webpos/order/save-note`, formData,{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      if (!response || !response.apiMessages || response.apiMessages.hasErrors) {
        this.$toast.error('Error while saving order note!')
        return false
      }
      return true;
    }catch (e) {
      this.$toast.error('Error while saving order note!')
      return false;
    }
  },

  async deleteOrderNote({commit, state}, {id}){
    try {
      const response = await this.$axios.$delete(`/webpos/order/note/${id}`)
      if (!response ||!response.apiMessages || response.apiMessages.hasErrors) {
        this.$toast.error('Error while deleting order note!')
        return false
      }
      return true;
    }catch (e) {
      this.$toast.error('Error while deleting order note!')
      return false;
    }
  },

  async deleteOrderById({ commit }, { id }) {
    try {
      await this.$axios.$delete(`/webpos/order/${id}`);
      this.$toast.success(`Order deleted successfully.`);
      return true;
    } catch (e) {
      this.$toast.error('Error while deleting order!');
      return false;
    }
  },

  async deleteOrderNoteAttachment({commit}, {jobNoteId, id}){
    try {
      const response = await this.$axios.$delete(`/webpos/order/note/${jobNoteId}/attachment/${id}`)
      if (!response || !response.apiMessages || response.apiMessages.hasErrors) {
        this.$toast.error('Error while deleting order note attachment!')
        return false
      }
      return true;
    }catch (e) {
      this.$toast.error('Error while deleting order note attachment!')
      return false;
    }
  },
  async fetchOrderItemImages({commit, state}, {jobID}) {
    const result = await this.$axios.$get(`/webpos/order/${jobID}/item-images/`)
    if (result && !result.hasError) {
      commit('setOrderItemImages', {images: result.value})
      return result.value
    }
    else{
      this.$toast.error(result.errorMessages[0])
    }
  },

  removeImages({commit, state}){
    commit('setOrderItemImages', {images: []})
  },


  //get the order items
  async fetchOrderItems({commit, state}, {orderID, filter}) {
    const filterString = filter
      ? `?${new URLSearchParams(filter).toString()}`
      : '';
    const res = await this.$axios.get(`webpos/order/${orderID}/items${filterString}`)
    if(res && res.data && !res.data.hasErrors){
      return res.data.value
    }
    else{
      this.$toast.error('Error occured while getting order detail');
      return [];
    }
  },

  async fetchCheckoutDetail({commit, state}, orderID) {
   let orderData = null
   try{
     const res = await this.$axios.get(`webpos/order/${orderID}/checkout-detail`)
     if(res && res.data && !res.data.hasErrors){
       orderData =  res.data.value
     }
     else{
       this.$toast.error('Error occured while getting order detail');
     }
   }
   catch{
     this.$toast.error('Error occured while getting order detail');
   }
   return orderData;
  },

  async getInvoiceDetailForOrder({}, {orderID}) {
    try{
      const result = await this.$axios.$get(`/webpos/order/${orderID}/invoice-detail`);

      if(result && !result.hasErrors){
        return result.value;
      }
      else{
        this.$toast.error('Error while getting invoice details.')
        return {};
      }
    }
    catch{
      this.$toast.error('Error while getting invoice detail.')
      return {};
    }
  },

  async getJobTypeStatusTypes({}, {jobTypeCode}) {
    let statuses = []
    try{
      const url = `/webpos/order/${jobTypeCode}/statuses`;

      const result = await this.$axios.$get(url);

      if(result && !result.hasErrors){
        statuses = result.value;
      }
      else{
        this.$toast.error('Error while getting job type statuses')

      }
    }
    catch{
      this.$toast.error('Error while getting job type statuses')
    }

    return statuses;
  },

  async fetchOrderDetail({commit}, orderID) {
    let orderDetail = [];
    try{
      const result = await this.$axios.$get(`webpos/order/${orderID}/detail`);

      if(result && !result.hasErrors){
        orderDetail =  result.value;
      }
      else{
        this.$toast.error('Error while getting order details.')
      }
    }
    catch{
      this.$toast.error('Error while getting order details.')
    }
    return orderDetail;
  },

  async fetchOrderDetailByEncryptedId({commit}, encryptedID) {
    let orderDetail = [];
    try{
      const result = await this.$axios.$get(`webpos/order/by-encrypted-id/?encryptedID=${encodeURIComponent(encryptedID)}`);

      if(result && !result.hasErrors){
        orderDetail =  result.value;
      }
      else{
        this.$toast.error('Error while getting order details.')
      }
    }
    catch{
      this.$toast.error('Error while getting order details.')
    }
    return orderDetail;
  },

  async fetchOrderImages({commit, state}, {jobID}){
    let images = [];
    try{
      const result = await this.$axios.$get(`/webpos/order/${jobID}/images`)
      if (result && result.hasErrors === false) {
        images = result.value;
      }
      else{
        this.$toast.error(result.errorMessages[0]);
      }
    } catch(error){
      this.$toast.error("Error while getting job images");
    }

    return images;
  },


  async fetchOrderHistory({},{filters, pagingInfo, customerID}){
    let ordersHistory = null;
    try{
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let url = `/webpos/customers/${customerID}/orders?${new URLSearchParams(filter).toString()}`;

      const result = await this.$axios.$get(url);

      if(result && !result.hasErrors){
        ordersHistory = result
      }
      else{
        this.$toast.error("Error while getting order history.")
      }

    }catch(e){
      this.$toast.error("Error while getting order history.")
    }
    return ordersHistory;
  },

  async getVariantIDBasedOnParentItemAttributes({}, {searchVariantData}){
    let searchVariantResult = [];
    try{
      const result = await this.$axios.$post(`/webpos/order/search-variants`, searchVariantData);

      if(!result || !result.apiMessages || result.apiMessages.hasErrors){
        this.$toast.error('Error while searching variants')
        return;
      }
      searchVariantResult = result.value;
    }
    catch{
      this.$toast.error('Error while searching variants')
    }

    return searchVariantResult;
  },

  async generateInvoice({commit}, order) {
    let generatedInvoiceCode = null

    try{
      const result = await this.$axios.$post(`/webpos/order/${order.id}/generate-invoice`)

      if (result && result.value) {
        generatedInvoiceCode = result.value;
        this.$toast.success(`Invoice with code: ${generatedInvoiceCode} generated successfully`)
      }
      else {
        this.$toast.error(`An error occurred while generating invoice for job '${order.code}'.`)
      }
    }
    catch (error) {
      this.$toast.error(`An error occurred while generating invoice for job '${order.code}'.`)
    }
    return generatedInvoiceCode
  },

  async getOrderTypes(){
    let orderTypes = [];
    try{
      const result = await this.$axios.$get(`/webpos/order/types`)
        if (!result?.value || result.apiMessages?.hasErrors) {
          this.$toast.error('Error while getting order types')
        }
        else{
          orderTypes = result.value;
        }
    }
    catch(e){
      this.$toast.error('Error while getting order types')
    }
    return orderTypes
  },

  async getSalesCommissionsForOrder({commit}, {orderID, filter}){
    let salesCommissions = [];
    try{
      const result = await this.$axios.$get(`/webpos/order/${orderID}/sales-account-commissions?${new URLSearchParams(filter).toString()}`)
      if (!result?.value || result.apiMessages?.hasErrors) {
        this.$toast.error('Error while getting sales commissions')
      }
      else{
        salesCommissions = result.value;
      }
    }
    catch(e){
      this.$toast.error('Error while getting sales commissions')
    }
    return salesCommissions
  },

  async updateSalesCommissionsForOrder({commit}, {orderID, updatedOrder}){
    let success = true;
    try{
      await this.$axios.$post(`/webpos/order/${orderID}/sales-account-commissions`, updatedOrder)
      this.$toast.success('Sales commissions updated successfully')
    }
    catch(e){
      success = false;
      this.$toast.error('Error while updating sales commissions')
    }

    return success;
  },

  async markOrderNoteAsReadForCurrentUser({commit}, {orderId, entityTypeId}){
    try {
      await this.$axios.$post(`/webpos/order/${orderId}/mark-order-notes-as-read-for-current-user?entityTypeId=${entityTypeId}`);
      return true
    }
    catch (e) {
      console.error(e);
      this.$toast.error("Error occurred while marking order notifications as read for the current user!");
      return false
    }
  },

  async updateEntityFieldForOrder({}, {orderEntityFieldForUpdate}){
    try{
      await this.$axios.$put(`/webpos/order`, orderEntityFieldForUpdate)
      this.$toast.success("Order updated successfully");
      return true;
    }
    catch (e){
      this.$toast.error("Error occurred while updating order");
      return false;
    }
  },

  async deleteOrderItem({ commit }, { orderID, itemID, item }) {
    try {
      await this.$axios.$post(`/webpos/order/${orderID}/items/${itemID}`, item);

      this.$toast.success(`Order item deleted successfully`);
      return true;
    }
    catch (e) {
      this.$toast.error('Error while deleting order item');
      return false;
    }
  },

  async insertOrderItem({ commit }, { orderID, item }) {
    try {
      await this.$axios.post(`/webpos/order/${orderID}/items`, item);

      this.$toast.success(`Order item inserted successfully`);
      return true;
    }
    catch (e) {
      this.$toast.error('Error while inserting order item');
      return false;
    }
  },

  async updateOrderStatus({},{orderID, newStatusCode, payment, jobTypeCode}){
    try{
      const result = await this.$axios.put(`/webpos/order/${orderID}/status`, {
        newStatusCode: newStatusCode,
        payment: payment,
        jobSubTypeCode: jobTypeCode
      })

      if (result?.data?.apiMessages?.hasErrors) {
        this.$toast.error(result.data.apiMessages.serverErrors[0] || "Error while updating order status");
        return null;
      }

      return result.data.value;
    }
    catch(error){
      this.$toast.error("Error while updating order status");
      return null;
    }
  },
}
